import { jsonParse } from 'src/app/app.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { OnboardingManagerService } from './services/onboarding-manager.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChatBotComponent } from 'src/app/controls/components/chat-bot/chat-bot.component';

@Component({
  selector: 'app-onboarding-manager',
  templateUrl: './onboarding-manager.component.html',
  styleUrls: ['./onboarding-manager.component.scss'],
  providers: [OnboardingManagerService]
})
export class OnboardingManagerComponent implements OnInit, OnDestroy {
  @Input() newTab;
  @Input() current_tab;
  resume_details: any = {};
  requirement_details: any = {}
  vertical_tabs = [{
    title: 'Onboarding Details',
    id: 1,
    active: true,
    visible: 1,
  },
  {
    title: 'RESUME.attachments',
    id: 2,
    active: false,
    visible: 0,

  },
  {
    title: 'RESUME.communication_history',
    id: 3,
    active: false,
    visible: 0,

  },
  ]
  verification_status_list = [];
  sections: any = [
    {
      code: 5,
      lastDate: "2021-05-08 19:22:10",
      pending: 0,
      progressPercentage: null,
      sectionFields: JSON.parse("[{\"code\": 28, \"info\": \"Salutation\", \"title\": \"Salutation\", \"value\": null, \"isEdit\": 1, \"mandatory\": 1, \"dataStatus\": 1, \"dataTypeId\": 1, \"notesCount\": 0, \"placeHolder\": \"Enter Salutation\", \"validationScript\": \"minLength : 2, maxLength:5\"},{\"code\": 29, \"info\": \"First Name\", \"title\": \"First Name\", \"value\": null, \"isEdit\": 1, \"mandatory\": 0, \"dataStatus\": 1, \"dataTypeId\": 1, \"notesCount\": 0, \"placeHolder\": \"Enter First Name\", \"validationScript\": \"\"},{\"code\": 30, \"info\": \"Last Name\", \"title\": \"Last Name\", \"value\": null, \"isEdit\": 1, \"mandatory\": 0, \"dataStatus\": 1, \"dataTypeId\": 1, \"notesCount\": 0, \"placeHolder\": \"Enter Last Name\", \"validationScript\": \"\"}]"),
      title: "Personal Information",
      validationScript: "",
    }
  ]
  s = [{
    title: 'Demo',
    active_section: true,
    percentage: 43
  }, {
    title: 'F',
    active_section: false,
    percentage: 93
  }];
  tab_details: any = {};
  alertId = 0;
  onboarding_form: UntypedFormGroup = new UntypedFormGroup({});
  current_action: any;
  constructor(
    private api: OnboardingManagerService,
    private notification: NotificationService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.sections.forEach(section => {
      section.sectionFields = jsonParse(section.sectionFields)
      this.onboarding_form.addControl(section.title, new UntypedFormGroup({}))
      if (section.sectionFields && section.sectionFields.length) {
        section.sectionFields.forEach(field => {

          if (field.validationScript && field.validationScript != '') {
            try {
              let objects = field.validationScript.split(",");
              objects.forEach(o => {
                let arr = o.split(":");
                if (arr && arr.length > 1) {
                  field[arr[0].trim()] = arr[1].trim();
                }
              })
            }
            catch (err) {

            }
          }

          let form: any = this.onboarding_form.get(section.title)
          form.addControl(field.title, new UntypedFormControl(field.value))
          form.get(field.title).setValidators([Validators.required, Validators.minLength(field.minLength), Validators.maxLength(field.maxLength), Validators.pattern(field.pattern), Validators.min(field.min), Validators.max(field.max)])

          form.get(field.title).updateValueAndValidity();
        })
      }
    })
    // this.loadDynamicSections();
    // this.loadApplicantSummary(this.tab_details.data.data.selected_entries[0].alertId)
    // this.loadRequirementSummary(this.tab_details.data.data.selected_entries[0].productCode)
  }
  ngOnDestroy() {
  }
  loadApplicantSummary(alertId) {
    this.api.getApplicantSummary({
      alertId: alertId
    }).subscribe(res => {
      if (res && res['data']) {
        this.resume_details = res['data'].detail;
      }
    })
  }
  loadRequirementSummary(productCode) {
    this.api.getRequirementSummary({
      productCode: productCode
    }).subscribe(res => {
      if (res && res['data']) {
        this.requirement_details = res['data'].requirementSummary;
      }
    })
  }

  loadDynamicSections(alertId?) {
    this.alertId = alertId
    let s = this.api.getDynamicSections({
    }).subscribe(res => {
      if (res && res['data'] && res['status']) {
        this.sections = res['data'].list;
        this.sections.forEach(section => {
          section.sectionFields = jsonParse(section.sectionFields)
          this.onboarding_form.addControl(section.title, new UntypedFormGroup({}))
          if (section.sectionFields && section.sectionFields.length) {
            section.sectionFields.forEach(field => {

              if (field.validationScript && field.validationScript != '') {
                try {
                  let objects = field.validationScript.split(",");
                  objects.forEach(o => {
                    let arr = o.split(":");
                    if (arr && arr.length > 1) {
                      field[arr[0].trim()] = arr[1].trim();
                    }
                  })
                }
                catch (err) {

                }
              }

              let form: any = this.onboarding_form.get(section.title)
              form.addControl(field.title, new UntypedFormControl(field.value))
              form.get(field.title).setValidators([Validators.required, Validators.minLength(field.minLength), Validators.maxLength(field.maxLength), Validators.pattern(field.pattern), Validators.min(field.min), Validators.max(field.max)])

              form.get(field.title).updateValueAndValidity();
            })
          }
        })
        this.verification_status_list = res['data'].dataStatusList;
        if (s) {
          s.unsubscribe();
        }
      }
      else {
        this.notification.error(res['message'], 'Close', 5000);
      }
      if (s) {
        s.unsubscribe();
      }
    })
  }
  sidebarClick(item) {
    if (item) {
      this.vertical_tabs.forEach(tab => {
        tab.active = false;
        if (tab.id == item.id) {
          tab.active = true;
        }
      })
    }
  }
  newTabEvent(type) {

    if (this.newTab) {

      try {
        if (type == 7) {
          this.newTab(7, null, null)
        }
        else if (type == 4) {
          // this.newTab(4, null, { productCode: this.resumeBankForm.value.productCode })
        }
      }
      catch (err) {

      }
    }
  }
  openRequirementTab(ev) {

  }

  dial(transaction) {

  }
  dataSaved(ev) {

    if (ev) {
      ev['alertId'] = this.alertId;
      ev['sectionCode'] = ev.code;
      let s = this.api.saveSection(ev).subscribe(res => {
        if (res && res['status']) {
          this.notification.success(res['message'], 'Close', 5000);
        }
        else {
          this.notification.error(res['message'], 'Close', 5000)
        }
      })
    }

  }
  cellClicked(ev) {
    if (ev && ev.func) {
      try {
        this[ev.func](ev.data);
      }
      catch (err) {

      }
    }
  }
  openNotes(item) {
    item['alertId'] = this.alertId;
    if (this.resume_details) {
      item['username'] = this.resume_details.firstName + ' ' + this.resume_details.lastName;
    }
    this.dialog.open(ChatBotComponent, {
      width: '40%',
      minWidth: '500px',
      panelClass: "TM-Dialog",
      data: item,
      height: 'auto',
      maxHeight: '80vh'
    }).afterClosed().subscribe(res => {
      if (res) {

      }
    })
  }
  setSectionVerticleNavbar(section) {
    section.active_section = true;
    this.current_action = section;
  }
}
